import { CalculateTour } from '@/domain/impact-calculate-tour/entities/calculate-tour.entity';
import { EMPTY_CALCULATE_TOUR_CO2 } from '@/domain/impact-calculate-tour/entities/calculate-tour-co2.entity';
import { EMPTY_CALCULATE_TOUR_ENV } from '@/domain/impact-calculate-tour/entities/calculate-tour-env.entity';
import { EMPTY_CALCULATE_TOUR_ESS } from '@/domain/impact-calculate-tour/entities/calculate-tour-ess.entity';

import { TopicsGlobalScoreData } from '../entities/calculate.entity';

export function prepareTopicsGlobalScoreDataTour(
  calculate: CalculateTour | null,
): TopicsGlobalScoreData {
  const env = calculate?.env || EMPTY_CALCULATE_TOUR_ENV;
  const ess = calculate?.ess || EMPTY_CALCULATE_TOUR_ESS;
  const co2 = calculate?.co2 || EMPTY_CALCULATE_TOUR_CO2;
  return {
    projectMode: 'tour',
    co2: {
      scoreLetter: '-',
      score: co2.global.score,
      kgeCO2ByParticipant: 0,
    },
    env: {
      scoreLetter: env.general.scoreLetter,
      score: env.general.score,
      maxScore: env.general.maxScore,
    },
    ess: {
      scoreLetter: ess.general.scoreLetter,
      score: ess.general.score,
      maxScore: ess.general.maxScore,
    },
  };
}
